// Version 0.0.1
// Author : VAIBAV
// MODIFIED DATA : 23-12-2025

const COLLECTION_FORMATReportTypes = {
	/*********************************FETCH CollectionFormat DETAILS START********************************/
	FETCH_COLLECTION_FORMAT_REPORT_START: 'fetch_Collection_Format_ReportStart',
	FETCH_COLLECTION_FORMAT_REPORT_SUCCESS: 'fetch_Collection_Format_ReportSuccess',
	FETCH_COLLECTION_FORMAT_REPORT_FAILURE: 'fetch_Collection_Format_ReportFailure',
	FETCH_COLLECTION_FORMAT_REPORT_RESPONSE_RESET_START:
		'fetch_Collection_FormatReportResponseResetStart',
	FETCH_COLLECTION_FORMAT_REPORT_RESPONSE_CHANGED:
		'fetch_Collection_Format_ReportResponseResetChanged',
	/******************************FETCH CollectionFormat DETAILS END******************** */
};

export default COLLECTION_FORMATReportTypes;
